import config from "../../config";
const baseUrl = config.baseUrl;

export const JobApplicationUrls = {

 JOB_APPLICATIONS_ADD: baseUrl + "/jobApplications",
 JOB_APPLICATIONS_EDIT: baseUrl + "/jobApplications",
 JOB_APPLICATIONS_STATUS: baseUrl + "/jobApplications/changedStatus",
 JOB_APPLICATIONS_LIST: baseUrl + "/jobApplications",
 JOB_APPLICATIONS_DELETE: baseUrl + "/jobApplications",
 JOB_APPLICATIONS_GETBYID: baseUrl + "/jobApplications",
 JOB_APPLICATIONS_ROLLBACK: baseUrl + "/jobApplications/rollback",
 JOB_APPLICATIONS_DROPDOWN: baseUrl + "/jobApplications/dropdown?export=true", 
 JOB_APPLICATIONS_DROPDOWN_HANDYMAN: baseUrl + "/jobApplications/dropdown?export=true&role=3", 
 JOB_APPLICATIONS_DELETE_HARD: baseUrl + "/jobApplications",
 PATIENT_COUNT:baseUrl+"/patients/visitcount"
};